import { render, staticRenderFns } from "./activity-user-info.component.vue?vue&type=template&id=df30c4bc&scoped=true"
import script from "./activity-user-info.component.vue?vue&type=script&lang=js"
export * from "./activity-user-info.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df30c4bc",
  null
  
)

export default component.exports